export { default } from './ponyfillGlobal';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/ponyfillGlobal/index.js
// module id = 1593
// module chunks = 22